import { render, staticRenderFns } from "./Capture.vue?vue&type=template&id=94ba2a04&scoped=true"
import script from "./Capture.vue?vue&type=script&lang=js"
export * from "./Capture.vue?vue&type=script&lang=js"
import style0 from "./Capture.vue?vue&type=style&index=0&id=94ba2a04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ba2a04",
  null
  
)

export default component.exports